import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { FaqPagosComponent } from './@pages/compania/faq-pagos/faq-pagos.component';
import { MensajerosRegistroComponent } from './@pages/compania/mensajeros/mensajeros-registro/mensajeros-registro.component';
import { PoliticaDatosComponent } from './@pages/compania/politica-datos/politica-datos.component';
import { TerminosCondicionesComponent } from './@pages/compania/terminos-condiciones/terminos-condiciones.component';
import { RegistroComponent } from './@pages/compania/tiendas/registro/registro.component';
import { MensajesComponent } from './@pages/pedidos/mensajes/mensajes.component';
import { NotificacionesComponent } from './@pages/pedidos/notificaciones/notificaciones.component';
import { RastreoComponent } from './@pages/pedidos/rastreo/rastreo.component';
import { EnviaComponent } from './@pages/pedidos/tracking/envia/envia.component';
import { ServientregaComponent } from './@pages/pedidos/tracking/servientrega/servientrega.component';
import { CheckoutComponent } from './layout/checkout/checkout.component';
import { CotizadorComponent } from './layout/cotizador/cotizador.component';
import { FinalTransaccionComponent } from './layout/final-transaccion/final-transaccion.component';
import { AyudaComponent } from './layout/inicio-n/ayuda/ayuda.component';
import { BeneficiosComponent } from './layout/inicio-n/beneficios/beneficios.component';
import { BilleteraComponent } from './layout/inicio-n/billetera/billetera.component';
import { BlogComponent } from './layout/inicio-n/blog/blog.component';
import { DetalleBComponent } from './layout/inicio-n/blog/detalle-b/detalle-b.component';
import { HomeComponent } from './layout/inicio-n/home/home.component';
import { InicioNComponent } from './layout/inicio-n/inicio-n.component';
import { LoginMobileComponent } from './layout/inicio-n/login-mobile/login-mobile.component';
import { LoginComponent } from './layout/inicio-n/login/login.component';
import { Registro2Component } from './layout/inicio-n/registro2/registro2.component';
import { IpVerificaComponent } from './layout/ip-verifica/ip-verifica.component';
import { Login3Component } from './layout/login3/login3.component';
import { NivelesComponent } from './layout/niveles/niveles.component';
import { AuthGuard } from '~shared/guards/auth.guard';

const routes: Routes = [
  {
    path: '',
    component: InicioNComponent,
    children: [
      {
        path: `pedidos`,
        loadChildren: () =>
          import('./@pages/pedidos/pedidos.module').then(
            (m) => m.PedidosModule
          ),
      },
      { path: '', component: LoginComponent },
      { path: 'somos-triidy', component: BilleteraComponent },
      { path: 'beneficios', component: BeneficiosComponent },
      { path: 'iniciar-sesion', component: LoginComponent },
      { path: 'ayuda', component: AyudaComponent },
      { path: 'blog', component: BlogComponent },
      { path: 'blog/detalle', component: DetalleBComponent },
      { path: 'cotizador', component: CotizadorComponent },
    ],
  },
  { path: 'registro/:id', component: Registro2Component },
  { path: 'trabaja-con-nosotros', component: MensajerosRegistroComponent },
  { path: 'registrate', component: RegistroComponent },
  { path: 'registrate/:id', component: RegistroComponent },
  {
    path: ``,
    loadChildren: () =>
      import('./@pages/dashboard/dashboard.module').then(
        (m) => m.DashboardModule
      )
  },
  {
    path: ``,
    loadChildren: () =>
      import('./@pages/compania/compania.module').then(
        (m) => m.CompaniaModule
      ),
  },
  { path: 'ipVerify', component: IpVerificaComponent },
  { path: 'terminos-condiciones', component: TerminosCondicionesComponent, canActivate: [AuthGuard] },
  { path: 'faq', component: FaqPagosComponent },
  { path: 'politicas-de-privacidad', component: PoliticaDatosComponent },
  { path: 'cotizador-m', component: CotizadorComponent },
  { path: 'login-externo/:tokey', component: Login3Component },
  { path: 'loginMobile', component: LoginMobileComponent },
  { path: 'loginMobile/:token', component: LoginMobileComponent },
  { path: 'r/:id', component: RastreoComponent },
  { path: 'rastreoEnvia/:id/:serv', component: EnviaComponent },
  { path: 'rastreoServientrega/:id', component: ServientregaComponent },
  { path: 'mensajes', component: MensajesComponent },
  { path: 'mensajes/:usr', component: MensajesComponent },
  { path: 'notificaciones', component: NotificacionesComponent },
  { path: 'notificaciones/:id', component: NotificacionesComponent },
  { path: 'niveles', component: NivelesComponent },
  { path: 'niveles/:lvl', component: NivelesComponent },
  { path: 'final-transaccion', component: FinalTransaccionComponent },
  { path: 'final-transaccion/:tipo/:referencia', component: FinalTransaccionComponent },
  { path: 'checkout/:referencia', component: CheckoutComponent },
  { path: '', redirectTo: '/', pathMatch: 'full' },
  { path: '**', pathMatch: 'full', redirectTo: '/' }
];


@NgModule({
  imports: [RouterModule.forRoot(routes, {
    scrollPositionRestoration: 'enabled',
    anchorScrolling: 'enabled',
    scrollOffset: [0, 64]
  })],
  exports: [RouterModule],
})
export class AppRoutingModule { }
